<template>
    <vs-card class="content_mb_0 mb-0">
        <div slot="header">
            <h4>Settings</h4>
        </div>
        <div>
            <vs-tabs class="normal_tab">
                <vs-tab label="Schedule Settings">
                    <Schedule />
                </vs-tab>

                <vs-tab label="Certificate Settings">
                    <Certificate />
                </vs-tab>

                <vs-tab label="Chat Settings">
                    <Chat />
                </vs-tab>
            </vs-tabs>
        </div>
    </vs-card>
</template>

<script>
import Schedule from './schedule.vue'
import Certificate from './certificate.vue'
import Chat from './chat.vue'

export default {
  components: {
    Schedule,
    Certificate,
    Chat
  }
}
</script>